module.exports = __webpack_public_path__ + "img/product_3.60690f7.webp";